import React, {useState, useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';

import scrollIntoView from 'scroll-into-view-if-needed';

import IconSelector from '@ibibo/icon-selector';
import {
  setUserSetting,
  setGccUserSetting,
  getGccMyProfile,
  getUserSetting,
} from '@ibibo/myaccount-reducer';

import * as S from './LeftBlock.styles';

import {getCookie} from './../../../../utils/getCookie';

const LeftBlock = ({userInfo}) => {
  const dispatch = useDispatch();

  const imageUploader = useRef(null);

  const [activeTab, setActiveTab] = useState('profileTab');

  const [{whitelabel_logo_image_url, company_name, sub_user}, setUserInfo] = useState({
    whitelabel_logo_image_url: userInfo.whitelabel_logo_image_url
      ? userInfo.whitelabel_logo_image_url.value
      : '',
    company_name: userInfo.company_name ? userInfo.company_name.value : '',
    sub_user: userInfo?.is_sub_user ? userInfo?.is_sub_user : false,
  });

  useEffect(() => {
    setUserInfo({
      whitelabel_logo_image_url: userInfo.whitelabel_logo_image_url
        ? userInfo.whitelabel_logo_image_url.value
        : whitelabel_logo_image_url,
      company_name: userInfo.company_name ? userInfo.company_name.value : company_name,
      sub_user: userInfo?.is_sub_user ? userInfo?.is_sub_user : false,
    });
  }, [userInfo]);

  const updateTab = tab => {
    setActiveTab(tab);
    scrollIntoView(document.getElementById(tab), {
      block: tab === 'companyTab' ? 'start' : 'center',
      behavior: 'smooth',
    });
  };

  const ccdeCookie = getCookie('ccde');

  const handleImageUpload = e => {
    const [file] = e.target.files;
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onloadend = () => {
        ccdeCookie == 'AE'
          ? dispatch(
              setGccUserSetting(
                {
                  whitelabel_logo: file,
                  // whitelabel_logo_base64: reader.result
                },
                () => {
                  dispatch(
                    getGccMyProfile(
                      () => {},
                      () => {},
                    ),
                  );
                },
                () => {},
              ),
            )
          : dispatch(
              setUserSetting(
                {
                  whitelabel_logo: file,
                  // whitelabel_logo_base64: reader.result
                },
                () => {
                  dispatch(
                    getUserSetting(
                      () => {},
                      () => {},
                    ),
                  );
                },
                () => {},
              ),
            );
      };
    }
  };

  return (
    <S.LeftBloackMainWrap>
      <S.LeftInnerBlock>
        <S.LogoWrap>
          <S.LogoImgWrap>
            {whitelabel_logo_image_url ? (
              <img className="profileImage" src={whitelabel_logo_image_url} />
            ) : (
              <IconSelector iconKey="profiledefault" />
            )}
            {!sub_user && (
              <S.AddLogoTag onClick={() => imageUploader.current.click()}>
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  multiple={false}
                  onChange={handleImageUpload}
                  ref={imageUploader}
                />
                <S.TagText>Add Logo</S.TagText>
              </S.AddLogoTag>
            )}
          </S.LogoImgWrap>
          <S.LogoImgSizeText>
            The optimized dimensions for the white-label logo are 40*40
          </S.LogoImgSizeText>
        </S.LogoWrap>
        <S.NameWrap>
          <S.NameText>{company_name}</S.NameText>
        </S.NameWrap>
        <S.MenuListWrap>
          <li
            id="profileTab"
            className={activeTab === 'profileTab' ? 'active' : ''}
            onClick={() => updateTab('profileTab')}
          >
            <IconSelector iconKey="profile" props={{margin: '0 1rem 0 0'}} />
            Profile
          </li>
          <li
            id="companyTab"
            className={activeTab === 'companyTab' ? 'active' : ''}
            onClick={() => updateTab('companyTab')}
          >
            <IconSelector iconKey="company" props={{margin: '0 1rem 0 0'}} />
            Company Details
          </li>
        </S.MenuListWrap>
      </S.LeftInnerBlock>
    </S.LeftBloackMainWrap>
  );
};

export default LeftBlock;
